import "./App.css";
import { Circle_Container } from "./Components/Circle-Container";
import { Empty_Container } from "./Components/Empty-Container";
import { Input_Container } from "./Components/Input-Container";
import React from "react";

function App() {
  var arr = [];
  function getRandomColor() {
    var letters = "0123456789ABCDEF";

    for (let i = 0; i < 5; i++) {
      var color = "#";
      for (let j = 0; j < 6; j++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      arr.push(color);
    }
    return arr;
  }
  getRandomColor()
  return (
    <div className="parentContainer">
      <Empty_Container randomColor={arr }/>
      <Circle_Container randomColor={arr }/>
      <Input_Container />
    </div>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js